import React, { useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import {
  Row,
  Column,
  BlockTransparent
} from 'common/components/styleguide/grid';

import { LISTING_LAYOUT_ROWS } from 'common/constants/SiteConstants'

import loadable from '@loadable/component';
const ProductCard = loadable(() => import(`common/blocks/product/card`));

import {
  getListingLayoutSelector,
  getPageDataSelector
} from 'common/selectors/page';

import { fireGTMEvent, getGTMCategoryList } from 'common/utils/gtm';
import {
  PRODUCT_VIEW,
  PAGE_VIEW
} from 'common/constants/GTMConstants';

const Listing = ({ products, activeLayout, GTMCategoryList }) => {
  if (!_.isEmpty(products)) {
    return (
      <BlockTransparent marginConfig={{bottom:true}}>
        <Row>
          {_.map(products, (product, i) => {
            return (
              <Column
                size={
                  LISTING_LAYOUT_ROWS == activeLayout
                    ? { xs: 12 }
                    : { xs: 6, sm: 4, md: 4, lg: 3, xl: 2 }
                }
                key={'products-listing-column-' + _.get(product, 'id', i)}
                paddingUseBottom={true}
              >
                <ProductCard
                  data={product}
                  showTitleOnTop={false}
                  showBrandOnTop={false}
                  showBrand={true}
                  showLabels={true}
                  imageWidth={420}
                  imageHeight={440}
                  lazyload={false}
                  layout={activeLayout}
                  GTMCategoryList={GTMCategoryList}
                />
              </Column>
            );
          })}
        </Row>
      </BlockTransparent>
    );
  }
  return null;
};

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const getListingLayout = getListingLayoutSelector();
  return (state, props) => {
    return {
      products: _.get(getPageData(state, props), 'products', null),
      activeLayout: getListingLayout(state, props)
    };
  };
};

export default connect(makeMapStateToProps)(Listing);
